import React from "react";
import { Link } from "react-router-dom";
import { useT } from "~/lib/i18n";

export default function NotFound(): React.JSX.Element {
  const { t } = useT();
  return (
    <div className="w-full max-w-[700px] mx-auto px-5 py-20">
      <span className="mono text-[11px] uppercase tracking-[0.12em] text-ink-tertiary">{t("web.404.kicker")}</span>
      <h1 className="mt-2 font-display text-[34px] leading-[42px] text-ink-primary">{t("web.404.title")}</h1>
      <p className="mt-3 text-[15px] text-ink-secondary">{t("web.404.body")}</p>
      <Link
        to="/"
        className="mt-6 inline-flex h-9 items-center gap-2 rounded-[4px] border border-[var(--divider-strong)] px-3.5 text-[13.5px] font-medium text-ink-primary hover:bg-surface-hover"
      >
        {t("web.404.cta")}
      </Link>
    </div>
  );
}
